import { Editor, TLShapeUtilConstructor, createTLStore } from '@tldraw/tldraw'
import { useEffect, useRef } from 'react'
import { shapeUtils } from '../VisualEditor'
import { getTextStyles } from '../helpers'

/**
 * Extracts title and body text styles from a design content object.
 *
 * @returns A function that accepts a design content object and returns an
 * array of text styles.
 */
export const useExtractTextStyles = () => {
  const tlStore = useRef(createTLStore({ shapeUtils }))

  const editor = useRef(
    new Editor({
      store: tlStore.current,
      shapeUtils: shapeUtils as TLShapeUtilConstructor<any, any>[],
      tools: [],
      getContainer: () => document.createElement('div'),
    }),
  )

  useEffect(() => editor.current.dispose(), [])

  return (content: any) => {
    tlStore.current.loadSnapshot(content)

    return getTextStyles(editor.current)
  }
}
